import { render, staticRenderFns } from "./CosmoBanner.vue?vue&type=template&id=634a5bda"
var script = {}
import style0 from "./CosmoBanner.vue?vue&type=style&index=0&id=634a5bda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports